export const REPORTED_KEY_VALUE_DISALLOWED_CHARACTERS: RegExp = /["'=!+#*~;^()<>[\],&\s]/ // https://support.google.com/admanager/answer/10020177
